<template>
  <div class="ml-m5">
    <div class="flex-container pl-10 mt-5">
      <div class="flex-item">
        <p>
          {{materialData.title}} :
          <strong class="text-bold">{{materialData.category}}</strong>
          <template v-if="materialData.business_division">
            |&nbsp;
            {{$t('INDENT_BUSINESS_DIVISION')}} :
            <strong class="text-bold">{{materialData.business_division}}</strong>
          </template>
        </p>
      </div>
    </div>
      <Collapse
        v-if="hasPackages"
        class="collapse-slider"
        v-model="activeTab">
        <CollapseItem :name="index"
          v-for="(packageDetail,index) in packagesList"
          :key="index">
          <template slot="title">
              <template v-if="packageDetail.isPackage">
                <strong class="mr-10">{{packageDetail.code}}</strong>
                <template v-if="packageDetail.reference_id">
                  <strong class="mt-m10"> __ </strong>
                  <span class="ml-10"> {{packageDetail.reference_id}} </span>
                </template>
              </template>
              <template v-else>
                Standalone Materials and Kits
              </template>
              <div v-if="packageDetail.isPackage && isEpodVisible" class="d-flex" style="justify-content: end; margin-left: auto; width: -webkit-fill-available;">
              <div @click="preventCollapseAction($event)" class="text-right">
                {{$t('INDENT_PACKAGE_SHORTAGE')}}
                <SwitchBtn
                  :value="getPackageDetail(packageDetail.id,'is_package_shortage')"
                  label="right"
                  size="small"
                  :disabled="!isEpodEditable"
                  class="default-switch"
                  @input="changePackageStatus(packageDetail.id,'is_package_shortage', $event)">
                </SwitchBtn>
                </div>
              <div @click="preventCollapseAction($event)" class="text-right ml-15">
                {{$t('INDENT_PACKAGE_DAMAGED')}}
                <SwitchBtn
                  :value="getPackageDetail(packageDetail.id,'is_package_damaged')"
                  label="right"
                  size="small"
                  :disabled="!isEpodEditable"
                  class="default-switch"
                  @input="changePackageStatus(packageDetail.id,'is_package_damaged', $event)">
                </SwitchBtn>
              </div>
              </div>
            </template>
            <MaterialsDetail
            :fixedColumns="fixedColumns"
            :editedPackageDetails="editedPackageDetails"
            :materialData="packageDetail"
            :modifiedMaterials.sync="modifiedMaterials"
            :orderNo="orderNo"
            :originalMaterialSummaries="originalMaterialSummaries"
            :slidableColumns="slidableColumns"
            :isEpodVisible="isEpodVisible"
            :isEpodEditable="isEpodEditable"
            :movement="movement"
            :canShowReturnMaterials="canShowReturnMaterials"
            :materialCustomColumn="materialCustomColumn"
            @updateComment="updateComment"
            @markAsModified="markAsModified"
            @open-sdlc-categorization="handleSdlcPopup"/>
        </CollapseItem>
      </Collapse>
      <MaterialsDetail
      v-else
      :fixedColumns="fixedColumns"
      :materialData="materialData"
      :originalMaterialSummaries="originalMaterialSummaries"
      :modifiedMaterials.sync="modifiedMaterials"
      :orderNo="orderNo"
      :slidableColumns="slidableColumns"
      :isEpodVisible="isEpodVisible"
      @open-sdlc-categorization="handleSdlcPopup"
      :isEpodEditable="isEpodEditable"
      :movement="movement"
      :canShowReturnMaterials="canShowReturnMaterials"
      :materialCustomColumn="materialCustomColumn"
      @updateComment="updateComment"
      @markAsModified="markAsModified"/>

    <SdlcCategorizationPopup
      v-model="sdlcPopupVisible"
      :material="sdlcPopupData.material"
      :order-no="sdlcPopupData.orderNo"
      :movement="movement"
      :order-status="orderStatus"
      @saved="handleSdlcSaved"
    />
  </div>
</template>
<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import { materialInvoiceOtpStatus } from 'pando-constants';
import { has } from 'lodash';
import MaterialsDetail from './materialsDetail';
import SdlcCategorizationPopup from '@/components/orders/documentation/SdlcCategorizationPopup';

export default {
  name: 'materialsDivision',
  props: {
    materialData: {
      type: Object,
      default: () => {},
    },
    fixedColumns: {
      type: Array,
      default: () => [],
    },
    slidableColumns: {
      type: Array,
      default: () => [],
    },
    modifiedMaterials: {
      type: Set,
      default: () => new Set(),
    },
    isEpodVisible: {
      type: Boolean,
      default: true,
    },
    isEpodEditable: {
      type: Boolean,
      defaut: false,
    },
    previousData: {
      type: Array,
      default: () => [],
    },
    editedPackageDetails: {
      type: Object,
      default: () => {},
    },
    movement: {
      type: Number,
    },
    orderNo: {
      type: String,
    },
    originalMaterialSummaries: {
      type: Object,
      default: () => {},
    },
    canShowReturnMaterials: {
      type: Boolean,
      default: () => false,
    },
    materialCustomColumn: {
      type: Array,
      default: () => [],
    },
    orderStatus: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      materialInvoiceOtpStatus,
      activeTab: [],
      sdlcPopupVisible: false,
      sdlcPopupData: { material: null, orderNo: '' },
    };
  },
  created() {
    this.activeTab = (this.materialData.packages &&
      Object.keys(this.materialData.packages)[0]) || null;
  },
  computed: {
    hasPackages() {
      return Boolean(this.materialData &&
        this.materialData.materials.some(val => val.packages && val.packages.length));
    },

    packagesList() {
      return this.materialData.materials
        .reduce((acc, material) => {
          if (material.packages && material.packages.length) {
            material.packages.forEach((matPack) => {
              if (!acc[matPack.id]) {
                acc[matPack.id] = Object.assign({
                  id: matPack.id,
                  reference_id: matPack.reference_id,
                  code: matPack.code,
                  name: `${matPack.code} - ${matPack.reference_id}`,
                  isPackage: true,
                }, this.materialData.packages[matPack.id]);
              }
              if (acc[matPack.id].materials) {
                acc[matPack.id].materials.push(material);
              } else {
                acc[matPack.id].materials = [material];
              }
            });
          } else if (acc.standalone) {
            acc.standalone.materials.push(material);
          } else {
            acc.standalone = { materials: [material] };
          }
          return acc;
        }, {});
    },
  },
  methods: {
    handleSdlcPopup({ material, orderNo }) {
      this.sdlcPopupData = { material, orderNo };
      this.$nextTick(() => {
        this.sdlcPopupVisible = true;
      });
    },
    handleSdlcSaved() {
      this.sdlcPopupVisible = false;
    },
    preventCollapseAction($event) {
      $event.stopPropagation();
    },
    getPackageDetail(packageId, key) {
      if (this.editedPackageDetails[packageId] &&
        has(this.editedPackageDetails[packageId], [key])) {
        return this.editedPackageDetails[packageId][key];
      }
      return this.materialData.packages[packageId][key];
    },
    getMaterialsByPackageId(packageId) {
      return this.materialData && this.materialData.materials ?
        this.materialData.materials
          .filter(val => val.package_ids && val.package_ids.includes(packageId)) : [];
    },
    markAsModified(materialId) {
      this.$emit('addModifiedMaterials', materialId);
    },
    updateComment(data) {
      this.$emit('update-comment', data);
    },
    changePackageStatus(packageId, key, value) {
      this.$emit('changePackageStatus', packageId, key, value);
    },
    addMaterialsShortage(materialsList) {
      const grnDetails = Object.assign({}, this.grnDetails);
      let resultObj = {};
      materialsList.forEach((material) => {
        resultObj[material.id] = Object.assign({ id: material.id }, material.epod,
          {
            shortage_count: material.quantity.value,
          });
        delete resultObj[material.id].is_submited;
      });
      resultObj = Object.assign({}, grnDetails, resultObj);
      this.$store.commit('order/ADD_ALL_GRN_DETAIL', resultObj);
    },
    getPackagesEditedData() {
      const result = [];
      Object.entries(this.editedPackageDetails).forEach(([id, data]) => {
        const obj = data;
        obj.id = id;
        result.push(obj);
      });
      return result;
    },
  },
  components: {
    MaterialsDetail,
    SdlcCategorizationPopup,
  },
};
</script>
